// src/firebase/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPhoneNumber } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyBtNs4HkW1WsxbnUVGoFtzju0W2iXrik-M",
  authDomain: "zoomo-eats.firebaseapp.com",
  projectId: "zoomo-eats",
  storageBucket: "zoomo-eats.firebasestorage.app",
  messagingSenderId: "279515098265",
  appId: "1:279515098265:web:15a584160e3e95e5b71c08",
  measurementId: "G-MZXDSP54VY",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app); // ✅ The one you should use
export const messaging = getMessaging(app);

export { signInWithPhoneNumber };
